export default references =>
  references.reduce((rmap, r) => {
    rmap[r.id] = r;
    return rmap;
  }, {});
